import { useCallback, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import BaseSelect from "react-select";
import FixRequiredSelect from "./FixRequiredSelect";

const options = [
    { value: 1, label: "1 - One" },
    { value: 2, label: "2 - Two" },
    { value: 3, label: "3 - Three" },
];

const Select = (props) => (
    <FixRequiredSelect
        {...props}
        SelectComponent={BaseSelect}
        options={props.options || options}
    />
);

const ModalDescargaSesiones = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const { estado, onCloseModal, onReturnValue, ClienteOCuenta, Lista } = props;
    const [listUsuarios, setListUsuario] = useState([]);
    const [formData, setFormData] = useState({ ID: "", fechaInicio: "", fechaFin: "" });

    const assigmentValue = useCallback(async () => {
        setListUsuario(Lista);
        setIsLoading(false);
    }, [Lista]);

    useEffect(() => {
        assigmentValue();
    }, [assigmentValue]);

    const handleSubmit = () => {
        console.log("handleSubmit");
        const submissionData = { ...formData };
        if (submissionData.ID === "TODOS") {
            submissionData.ID = undefined;
        }
        console.log(submissionData);
        onReturnValue(submissionData);
    };

    return (
        <Modal show={estado} onHide={onCloseModal} size="s">
            <Modal.Header closeButton>
                <Modal.Title>Generar Reporte de Marcaciones</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="card">
                    <div className="card-body">
                        <div className="form-validation">
                            <div className="form-group mb-2 row">
                                <label className="col-form-label">
                                    {ClienteOCuenta}
                                    <span className="text-danger">*</span>
                                </label>
                                <div>
                                    <Select
                                        options={listUsuarios}
                                        isLoading={isLoading}
                                        isSearchable
                                        required
                                        noOptionsMessage={() => "Sin Opciones"}
                                        onChange={(e) => {
                                            setFormData({
                                                ...formData,
                                                ID: e.value,
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="form-group mb-2 row">
                                <label className="col-form-label">
                                    Fecha Inicial
                                    <span className="text-danger">*</span>
                                </label>
                                <div>
                                    <input
                                        required
                                        type="date"
                                        className="form-control"
                                        onChange={(e) => {
                                            setFormData({
                                                ...formData,
                                                fechaInicio: e.target.value,
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="form-group mb-2 row">
                                <label className="col-form-label">
                                    Fecha Final
                                    <span className="text-danger">*</span>
                                </label>
                                <div>
                                    <input
                                        required
                                        type="date"
                                        className="form-control"
                                        onChange={(e) => {
                                            setFormData({
                                                ...formData,
                                                fechaFin: e.target.value,
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={onCloseModal}>
                    Cerrar
                </Button>
                <Button onClick={handleSubmit}>
                    Generar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalDescargaSesiones;